import React from "react";
import { translate } from "react-switch-lang";
import { Label, Input } from "reactstrap";
import { getYearsDropdownData } from "utils/date";

const YearsDropdown = ({ value, onChange, label = "Year", className = "" }) => {
  return (
    <div className={`${className}`}>
      <Label>{label}</Label>
      <Input
        type="select"
        name="select"
        value={value}
        className="form-control digits uiStyleDashboard"
        onChange={onChange}
      >
        {getYearsDropdownData().map((item) => (
          <option key={item} value={item}>
            {item}
          </option>
        ))}
      </Input>
    </div>
  );
};

export default YearsDropdown;
